// @ts-nocheck
/**
 * diffEngine.ts
 * レイヤーリストのスナップショット比較
 * 差分検出により、addLayers()のフルリビルドを回避
 */

export interface LayerSnapshot {
  id: string
  layerIds: string[]
  opacity: number
  visibility: boolean | undefined
}

export interface DiffResult {
  type: 'none' | 'property_only' | 'structural'
  changes?: LayerSnapshot[]
  added?: LayerSnapshot[]
  removed?: LayerSnapshot[]
  orderOnly?: boolean
  layersChanged?: boolean
}

/**
 * selectedLayersの軽量スナップショットを生成
 */
export function computeLayerSnapshot(selectedLayers: unknown[]): LayerSnapshot[] {
  return selectedLayers.map(layer => ({
    id: layer.id,
    layerIds: (layer.layers || []).map(l => l.id),
    opacity: layer.opacity,
    visibility: layer.visibility,
  }))
}

/**
 * 2つのスナップショットを比較して差分種別を返す
 * - structural: レイヤー追加/削除/順序変更/内部レイヤー変更
 * - property_only: opacity/visibilityのみ変更
 * - none: 変更なし
 */
export function diffLayerSnapshots(prev: LayerSnapshot[], current: LayerSnapshot[]): DiffResult {
  // 長さが違う or IDが違う or 順序が違う → structural
  if (prev.length !== current.length) {
    const prevIds = new Set(prev.map(s => s.id))
    const currentIds = new Set(current.map(s => s.id))
    const added = current.filter(s => !prevIds.has(s.id))
    const removed = prev.filter(s => !currentIds.has(s.id))
    return { type: 'structural', added, removed }
  }
  // 同じ長さ → ID順序比較
  let orderChanged = false
  for (let i = 0; i < prev.length; i++) {
    if (prev[i].id !== current[i].id) {
      orderChanged = true
      break
    }
  }
  if (orderChanged) {
    return { type: 'structural', added: [], removed: [], orderOnly: true }
  }
  // IDと順序は同じ → 内部レイヤー数の変化チェック（地番図の動的追加等）
  for (let i = 0; i < prev.length; i++) {
    const pIds = prev[i].layerIds
    const cIds = current[i].layerIds
    if (pIds.length !== cIds.length || pIds.some((id, j) => id !== cIds[j])) {
      return { type: 'structural', added: [], removed: [], layersChanged: true }
    }
  }
  // opacity/visibility差分チェック
  const changes: LayerSnapshot[] = []
  for (let i = 0; i < prev.length; i++) {
    const p = prev[i]
    const c = current[i]
    if (p.opacity !== c.opacity || p.visibility !== c.visibility) {
      changes.push({ id: c.id, layerIds: c.layerIds, opacity: c.opacity, visibility: c.visibility })
    }
  }
  if (changes.length > 0) {
    return { type: 'property_only', changes }
  }
  return { type: 'none' }
}
